import React, { useEffect, useState } from 'react';
// import { Container, Typography, FormControl, InputLabel, Input, Box, FormGroup, Button } from '@material-ui/core';
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {serviceGetarea, serviceGetClinic, serviceAddClinic} from  "../Services/Service";

const initialValue = {
    clinicName:"",
    areaSelect:"",
    email:"",
    btnValue: "",
    action:"",
    updateId:""
}

const PracticeAdd = () => {

    const [formData, setFormData] = useState(initialValue);
    const {clinicName,areaSelect,email,btnValue,action,updateId } = formData;
    const [areaData, setAreaData] = useState([]);

    const [isvalid, setIsvalid] = useState(true);
    
    const [formErrors, setFormErrors] = useState('');
    const [headTitle, setHeadTitle] = useState([]);

    const navigate = useNavigate();
    const { id } = useParams();
    
    const [alertInfo, setAlertInfo] = useState({
        visible : false,
        cls : '',
        msg :''
      });
    const onShowAlert = (msg,visible,clas)=>{
        setAlertInfo({...alertInfo, ['visible']: visible,['cls']:clas,['msg']: msg});
    }

    useEffect(() => {
        fetchArea();
        if(id != '' && id !== undefined){
            setHeadTitle('Update Practice');
            loadUserData();
        }else{
            setHeadTitle('Add Practice');
             setFormData({...formData, ['btnValue']: 'Add Practice',['action']: 'add'});
        }
        
    },[]);

    const   fetchArea = async () =>{
        
        const response = await serviceGetarea('');
        setAreaData(response.data.data.area);
        
        // onShowAlert();
    }

    const loadUserData = async () =>{
        
        const response = await serviceGetClinic(id);
        setFormData({...formData, ['btnValue']: 'Update',['action']: 'update',['updateId']: id,['clinicName']: response.data.data.clinic[0].name});
        // onShowAlert();
    }

    const onValueChange = (e) =>
    {
        setFormData({...formData, [e.target.name]: e.target.value});
    }

    
    function validateForm(){
        
        if(isvalid){
            setIsvalid(true);
            setFormErrors('');
        }   
        return isvalid;   
    }
    const submitHandle = e => {
        e.preventDefault();
        
        let isvalidForm = validateForm();
        if(isvalidForm && isvalid){
            
            serviceAddClinic(formData)
                .then((response) => {
  
                    if(typeof(response)!=='undefined'){
                        let clas = (response.data.status == "1") ? 'success' : 'danger';
                        if(response.data.status == "1" && formData.action=='add'){
                            setFormData({...formData, ['clinicName']: '',['areaSelect']:'',['email']:''});
                        }
                        onShowAlert(response.data.data.message,true,clas);    
                    }
                })
        }else{
            console.log('isvalid false');
        }
             
    }

    return (
        <>
            <section className='projects-section'>
            <div className='row'>
                <h1 className='title mb-4'>{headTitle}</h1>
                {alertInfo.visible ? <div className={"alert alert-"+ alertInfo.cls +" col-md-4 mb-2"} role="alert">{alertInfo.msg}</div> : null}

                {formErrors!='' ? <div className={"alert alert-danger col-md-4"} role="alert">{formErrors}</div> : null}
                

                <form onSubmit={submitHandle} className=''>
                
                <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="form2Example1" className="form-control" required name="clinicName" value={clinicName} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Practice Name</label>
                    </div>
                </div>

                <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3" >
                        <input type="email" id="form2Example4" className="form-control" required name="email" value={email} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Email address</label>
                    </div>
                </div>

                <div className="clearfix"></div> 
                <div className="col-md-6">
                    <div  className="form-floating mb-3"> 
                        <select id="areaSelect" name="areaSelect" className='form-control' required onChange={onValueChange} >
                            <option value="">-- SELECT DIVISION --</option>
                            {areaData.map((data, i) => (
                                // <option key={i} value={data.areaId}>{data.areaName}</option>
                                <option value={data.areaId} selected={data.areaId==areaSelect?true:false} key={i}>{data.areaName}</option>
                            ))}
                        </select>

                        <label className="form-label">Division</label>
                    </div>
                </div> 
                
                <div className="clearfix"></div>
                <div className="col-md-6 mt-3">
                    <button type="submit" className="btn btn-primary btn-login mb-4" name="btnValue">{formData.btnValue}</button>
                </div>
                    
                </form>
                </div>

</section>

        </>
    )
}


export default PracticeAdd;